// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__T0NOW","is-loaded":"Image_is-loaded___3xVp"};